import classNames from 'classnames';
import { ComponentProps } from 'react';
import { Button } from './Button';

export const SecondaryButton = ({
  className,
  ...props
}: ComponentProps<typeof Button>) => (
  <Button
    className={classNames(
      'bg-secondary-600 text-white',
      'disabled:bg-secondary-100',
      'disabled:text-secondary-400',
      'disabled:cursor-not-allowed',
      'hover:shadow-down-sm',
      'hover:bg-secondary-500',
      'text-caption-xl font-semibold',
      'transition',
      'ease-in',
      'relative',
      'rounded-3xl',
      'py-2 px-4',
      className
    )}
    type="submit"
    {...props}
  />
);
